Vendd.Scripts.load(function () {

    var Vendd = window.Vendd || {};

    var action = function (element, definition) {

        Vendd.inlineEdit.controlBase.apply(this, [element, definition]);

    };
    action.prototype = Object.create(Vendd.inlineEdit.controlBase.prototype);
    action.prototype.name = 'action';

    action.prototype.build = function () {

        var self = this;

        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.controlBase.prototype.build.apply(self); });

    };

    action.prototype.render = function () {

        var self = this;

        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.controlBase.prototype.render.apply(self); })
            .then(function() { self.element.addClass('hidden') });

    };

    action.prototype.bind = function () {

        var self = this;

        return Vendd.Promises.GetOrDefault(function() { return Vendd.inlineEdit.controlBase.prototype.bind.apply(self); });

    };

    action.prototype.Enabled = function () {

        return false;

    }

    Vendd.inlineEdit.action = action;

});